module.exports = __webpack_public_path__ + "static/img/menu-ml.cc20217.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-ml.png
// module id = mzSZ
// module chunks = 2